module.exports = __webpack_public_path__ + "img/2_215.20eaafb3.png";